module.exports = __webpack_public_path__ + "img/logo-orange.d2d6b191.png";